module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "bot-one light-black hvr-grow-rotate",
    attrs: {
      "aria-label": _vm.aria
    }
  }, [_c('p', [_c('span', {
    staticClass: "part-1"
  }, [_vm._v(_vm._s(_vm.partOne))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "part-2 font-red"
  }, [_vm._v(_vm._s(_vm.partTwo))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "part-3 font-red"
  }, [_vm._v(_vm._s(_vm.partThree))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18e0c71d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Buttoncircleprimary.vue
// module id = 949
// module chunks = 1